function DiscountForm() {
  return (
    <div className="border rounded p-4">
      <h5 className="fw-semibold mb-3">Create Discount</h5>

      <div className="row g-3">
        {/* Name */}
        <div className="col-md-6">
          <label className="form-label">Name</label>
          <input
            className="form-control"
            placeholder="Events, New Year Sale…"
          />
        </div>

        {/* Discount Type */}
        <div className="col-md-3">
          <label className="form-label">Discount Type</label>
          <select className="form-select">
            <option>Percentage (%)</option>
            <option>Fixed Amount</option>
          </select>
        </div>

        {/* Discount Value */}
        <div className="col-md-3">
          <label className="form-label">Value</label>
          <input className="form-control" placeholder="20 or 500" />
        </div>

        {/* Apply Scope */}
        <div className="col-md-6">
          <label className="form-label">Apply To</label>
          <select className="form-select">
            <option>All Products</option>
            <option>Selected Products</option>
          </select>
        </div>

        {/* Duration */}
        <div className="col-md-3">
          <label className="form-label">Start Date</label>
          <input type="date" className="form-control" />
        </div>

        <div className="col-md-3">
          <label className="form-label">End Date</label>
          <input type="date" className="form-control" />
        </div>

        {/* Actions */}
        <div className="col-12 mt-3">
          <button className="btn btn-primary">Create</button>
        </div>
      </div>
    </div>
  );
}
export default DiscountForm;
